import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  getTsunami as getTsunamiAc,
  getReferences as getReferencesAc,
  searchReferences as searchReferencesAc,
  clearRunup as clearRunupAc,
  createRunup as createRunupAc,
  getRunup as getRunupAc,
  searchTsunamis as searchTsunamisAc,
  updateRunup as updateRunupAc,
  getLocations as getLocationsAc,
  getCountries as getCountriesAc,
  getRegions as getRegionsAc,
  getAreas as getAreasAc,
  getFirstMotions as getFirstMotionsAc,
  getMeasurementTypes as getMeasurementTypesAc,
  sortTsunamis as sortTsunamisAc,
  sortReferences as sortReferencesAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
} from '../../../../../../redux/tsunamis/runups/edit/runupEditActions';
import { runupEditModel, createInitialForm, formToJson } from './runupEditModel';
import { LabeledCheckbox } from '../../../../../form/LabeledCheckbox';
import { AssociatedReferenceControl } from '../../../../../form/AssociatedReferenceControl';
import { AssociatedTsunamiControl } from '../../../../../form/AssociatedTsunamiControl';
import { CommentsEditor } from '../../../../../form/CommentsEditor';
import { EditForm } from '../../../../../form/EditForm';

const model = runupEditModel.get('name');
const initialValues = runupEditModel.get('initialValues');

class RunupEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Runup Edit';
    const {
      match: { params: { id } },
      getRunup,
      getTsunami,
      getReferences,
      getAreas,
      getCountries,
      getFirstMotions,
      getLocations,
      getRegions,
      getMeasurementTypes,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getRunup({ id, history });
      getTsunami({ id, history });
      getReferences({ id, history });
    }
    getLocations({ history });
    getAreas({ history });
    getCountries({ history });
    getFirstMotions({ history });
    getRegions({ history });
    getMeasurementTypes({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const {
      fetched, initializeForm, runup,
    } = this.props;
    const { initialized } = this.state;
    if (!initialized) {
      if (fetched) {
        const form = createInitialForm(runup);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearRunup,
    } = this.props;
    clearRunup();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, runup,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    change('', createInitialForm(runup));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      tsunami,
      searchReferences,
      references,
      referenceSearching,
      referenceSearchResults,
      searchTsunamis,
      tsunamiSearching,
      tsunamiSearchResults,
      areas,
      regions,
      countries,
      locations,
      firstMotions,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      measurementTypes,
      match: { params: { id } },
      tsuSort,
      sortTsunamis,
      refSort,
      sortReferences,
      history,
      createRunup,
      updateRunup,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      runup,
      toggleTsunamiColumns,
      tsuVisibleColumns,
      toggleReferenceColumns,
      refVisibleColumns,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Runup' : `Edit Runup: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Runup"
              saving={updating}
              create={createRunup}
              update={updateRunup}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={runup}
            >

              <AssociatedTsunamiControl
                model={model}
                tsunami={tsunami}
                searchTsunamis={config => searchTsunamis({ ...config, history })}
                tsunamiSearching={tsunamiSearching}
                tsunamiSearchResults={tsunamiSearchResults}
                sort={tsuSort}
                sortData={sortTsunamis}
                visibleColumns={tsuVisibleColumns}
                toggleColumns={toggleTsunamiColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Date and Location</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-4']} model=".year" label="Year" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".month" label="Month" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".day" label="Day" readOnly={updating} />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".latitude" label="Latitude" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".longitude" label="Longitude" readOnly={updating} />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={regions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="regionCode" label="Region" readOnly={updating} filterable prependId />
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="locationName" label="Location" readOnly={updating} filterable addable />
                  </div>


                  <div className="form-row">
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="country" label="Country" readOnly={updating} filterable addable />
                    <LabeledSelect childOptions={areas.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="area" label="Area" readOnly={updating} filterable addable />
                  </div>

                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardTitle tag="h2">Measurements</CardTitle>

                  <Card>
                    <CardBody>
                      <CardTitle>Travel Time</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-6']} model=".travHours" label="Hours" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-6']} model=".travMins" label="Minutes" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Arrival Time</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-4']} model=".arrDay" label="Day" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".arrHour" label="Hour" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".arrMin" label="Minute" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <CardTitle>Max Trough Time</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxTroughDay" label="Day" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxTroughHour" label="Hour" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxTroughMin" label="Minute" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Max Wave Arrival Time</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxWaveArrDay" label="Day" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxWaveArrHour" label="Hour" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-4']} model=".maxWaveArrMin" label="Minute" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>

                  <div className="form-row">
                    <LabeledSelect childOptions={measurementTypes.toJS()} formGroupClassName={['col-lg-3']} parentModel={model} fieldId="typeMeasurementId" label="Type of Measurement" filterable sorted={false} prependId />
                    <LabeledText formGroupClassName={['col-lg-3']} model=".runupHt" label="Max Height (m)" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-lg-3']} model=".maxTroughHt" label="Max Trough Height (m)" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-lg-3']} model=".runupHoriz" label="Max Horiz Inundation (m)" readOnly={updating} />
                  </div>

                  <div className="form-row">

                    <LabeledText formGroupClassName={['col-sm-3']} model=".period" label="Period" readOnly={updating} />
                    <LabeledSelect childOptions={firstMotions.toJS()} formGroupClassName={['col-sm-3']} parentModel={model} fieldId="firstMotion" label="First Motion" />
                    <LabeledSelect
                      formGroupClassName={['col-sm-6']}
                      parentModel={model}
                      fieldId="doubtful"
                      label="Doubtfulness"
                      sorted={false}
                      requiresValue
                      childOptions={[
                        { id: 'n', description: 'OK' },
                        { id: 'y', description: 'Doubtful' },
                        { id: 'm', description: 'Meteorological' },
                        { id: 'a', description: 'Atmospheric' },
                      ]}
                    />
                  </div>


                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Effects</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deaths" label="Deaths" readOnly={updating} />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrder" label="Deaths Description" readOnly={updating} sorted={false} prependId />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missing" label="Missing" readOnly={updating} />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrder" label="Missing Description" readOnly={updating} sorted={false} prependId />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuries" label="Injuries" readOnly={updating} />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrder" label="Injuries Description" readOnly={updating} sorted={false} prependId />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollars" label="Damage ($Mil)" readOnly={updating} />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrder" label="Damage Description" readOnly={updating} sorted={false} prependId />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyed" label="Houses Destroyed" readOnly={updating} />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrder" label="Houses Destroyed Description" readOnly={updating} sorted={false} prependId />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDamaged" label="Houses Damaged" readOnly={updating} />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDamagedAmountOrder" label="Houses Damaged Description" readOnly={updating} sorted={false} prependId />
                  </div>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Comments</CardTitle>
                  <CommentsEditor model={model} readOnly={updating} />
                </CardBody>
              </Card>

              <AssociatedReferenceControl
                model={model}
                initialReferences={references}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Checks</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".flagArrTravTimeChk" label="Arrival Time Checked" />
                    <LabeledCheckbox inline model=".flagLocChk" label="Location Checked" />
                    <LabeledCheckbox inline model=".flagRunupChk" label="Runup Checked" />
                    <LabeledCheckbox inline model=".flagEffectsChk" label="Effects Checked" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

RunupEditPageUnwrapped.propTypes = {
  getTsunami: PropTypes.func.isRequired,
  getReferences: PropTypes.func.isRequired,
  searchReferences: PropTypes.func.isRequired,
  clearRunup: PropTypes.func.isRequired,
  createRunup: PropTypes.func.isRequired,
  getRunup: PropTypes.func.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  updateRunup: PropTypes.func.isRequired,
  runup: ImmutablePropTypes.map.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  getLocations: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getAreas: PropTypes.func.isRequired,
  getFirstMotions: PropTypes.func.isRequired,
  getMeasurementTypes: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  areas: ImmutablePropTypes.list.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  firstMotions: ImmutablePropTypes.list.isRequired,
  measurementTypes: ImmutablePropTypes.list.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  tsuSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  toggleTsunamiColumns: PropTypes.func.isRequired,
  tsuVisibleColumns: ImmutablePropTypes.list.isRequired,
  toggleReferenceColumns: PropTypes.func.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,
};

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['runupEditPage', 'fetchedRegions']),
    state.getIn(['runupEditPage', 'fetchedCountries']),
    state.getIn(['runupEditPage', 'fetchedAreas']),
    state.getIn(['runupEditPage', 'fetchedLocations']),
    state.getIn(['runupEditPage', 'fetchedFirstMotions']),
    state.getIn(['runupEditPage', 'fetchedMeasurementTypes']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['runupEditPage', 'fetched']),
      state.getIn(['runupEditPage', 'fetchedTsunami']),
      state.getIn(['runupEditPage', 'fetchedReferences']),
    );
  }

  return {
    fetched: fetchedCheck.every(v => v),
    runup: state.getIn(['runupEditPage', 'runup']),
    tsunami: state.getIn(['runupEditPage', 'tsunami']),
    references: state.getIn(['runupEditPage', 'references']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['runupEditPage', 'updating']),
    referenceSearching: state.getIn(['runupEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['runupEditPage', 'referenceSearchResults']),
    tsunamiSearching: state.getIn(['runupEditPage', 'tsunamiSearching']),
    tsunamiSearchResults: state.getIn(['runupEditPage', 'tsunamiSearchResults']),
    housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
    damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
    peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
    regions: state.getIn(['runupEditPage', 'regions']),
    countries: state.getIn(['runupEditPage', 'countries']),
    areas: state.getIn(['runupEditPage', 'areas']),
    locations: state.getIn(['runupEditPage', 'locations']),
    firstMotions: state.getIn(['runupEditPage', 'firstMotions']),
    measurementTypes: state.getIn(['runupEditPage', 'measurementTypes']),
    tsuSort: state.getIn(['runupEditPage', 'tsuSort']),
    refSort: state.getIn(['runupEditPage', 'refSort']),
    formData: state.getIn(['runupEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['runupEditPage', 'editConfirmationOpen']),
    tsuVisibleColumns: state.getIn(['runupEditPage', 'tsuVisibleColumns']),
    refVisibleColumns: state.getIn(['runupEditPage', 'refVisibleColumns']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getTsunami: getTsunamiAc,
  getReferences: getReferencesAc,
  searchReferences: searchReferencesAc,
  clearRunup: clearRunupAc,
  createRunup: createRunupAc,
  getRunup: getRunupAc,
  searchTsunamis: searchTsunamisAc,
  updateRunup: updateRunupAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: initial => actions.load(model, initial),
  setPristine: () => actions.setPristine(model),
  getLocations: getLocationsAc,
  getCountries: getCountriesAc,
  getRegions: getRegionsAc,
  getAreas: getAreasAc,
  getFirstMotions: getFirstMotionsAc,
  getMeasurementTypes: getMeasurementTypesAc,
  sortTsunamis: sortTsunamisAc,
  sortReferences: sortReferencesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,
}, dispatch);

export const RunupEditPage = connect(mapStateToProps, mapDispatchToProps)(RunupEditPageUnwrapped);
